import { createContext, useContext } from 'react';

import type { Telephone } from '../telephony/useTelephone';

/**
 * The telephone as the office arranged it — desk, settings, and the call that is mine —
 * beside the browser telephone and mounted with it, once, above the routes.
 */
export const TelephoneContext = createContext<Telephone | null>(null);

export function useTelephoneContext(): Telephone {
  const telephone = useContext(TelephoneContext);

  if (telephone === null) {
    throw new Error('The telephone was used outside the console shell.');
  }

  return telephone;
}
